import { z } from "zod";

export const userSchema = z.object({
  password: z
    .string()
    .min(6, { message: "Password must be at least 6 characters" }),
});

export type TUserSchemaInput = z.infer<typeof userSchema>;
